<template>
    <div class="font-semibold text-lg">
        <slot />
    </div>
</template>
